import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import API from '../utils/api';

export default function Slokas() {
  const { t } = useTranslation();
  const [slokas, setSlokas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    API.get('/slokas').then(r => { setSlokas(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div>
      <div className="page-header">
        <h1 style={{ fontFamily: 'Noto Serif Devanagari, serif' }}>{t('slokas.pageTitle')}</h1>
        <p>{t('slokas.pageSubtitle')}</p>
      </div>

      <section className="section">
        <div className="container" style={{ maxWidth: 860 }}>
          <div style={{ textAlign: 'center', marginBottom: 40 }}>
            <p style={{ color: '#555', lineHeight: 1.8, fontSize: '1.05rem' }}>
              {t('slokas.intro')}
            </p>
          </div>

          {loading ? (
            <div className="loader"><div className="spinner" /></div>
          ) : (
            <div>
              {slokas.map(sloka => (
                <div key={sloka._id} className="sloka-card">
                  <div className="sloka-source">{sloka.source}</div>
                  <h3 className="sloka-title">{sloka.title}</h3>
                  <div className="sloka-sanskrit">{sloka.sanskrit}</div>
                  {sloka.transliteration && (
                    <div className="sloka-transliteration">{sloka.transliteration}</div>
                  )}
                  <div className="sloka-meaning">
                    <strong style={{ color: 'var(--saffron)' }}>{t('slokas.meaningLabel')} </strong>{sloka.meaning}
                  </div>
                </div>
              ))}
            </div>
          )}

          <div style={{ background: 'linear-gradient(135deg, #FFF8F0, #FFE8CC)', borderRadius: 16, padding: 32, textAlign: 'center', marginTop: 40 }}>
            <div style={{ fontSize: '2rem', marginBottom: 12 }}>🙏</div>
            <p style={{ fontFamily: 'Noto Serif Devanagari, serif', fontSize: '1.3rem', color: 'var(--saffron)', fontWeight: 600, marginBottom: 8 }}>
              गावो विश्वस्य मातरः
            </p>
            <p style={{ color: '#555', fontSize: '0.95rem' }}>
              {t('slokas.quoteGloss')}
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
